import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";
import { IconEditCoupon } from "../../../constant/icon";
import BaseButton from "../../button/BaseButton";
import { getCouponDetail } from "../../../api/order.api";
import { useLanguage } from "../../../hooks/useLanguage";
import { showToast } from "../../../utils/showToast";
import { useTranslation } from "react-i18next";

export default function ModalCoupon({
  ticket,
  setTicketUserBuy,
  ticketUserBuy,
}) {
  const { nameWithLanguage, currentLanguage } = useLanguage();
  const { t } = useTranslation();

  let [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [couponCode, setCouponCode] = useState("");

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
    setCouponCode("");
  }

  const onChangeCoupon = (e) => {
    setCouponCode(e.target.value);
  };

  const handleCheckCoupon = async () => {
    setLoading(true);
    try {
      const { data } = await getCouponDetail(ticket?.id, couponCode);
      showToast({ message: "Apply coupon success", type: "success" });
      const newTicket = { ...ticket, coupon: data };
      const newTicketBuy = ticketUserBuy.map((item) => {
        if (item?.id === newTicket?.id) return newTicket;
        return item;
      });

      setIsOpen(false);
      setTicketUserBuy(newTicketBuy);
    } catch (error) {
      showToast({ message: "Coupon not found or expired", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex items-center justify-center">
        <button type="button" onClick={openModal}>
          <IconEditCoupon />
        </button>
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg lg:p-10 bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-heading-3 text-center text-purple-900 mb-6"
                  >
                    {t("enter_coupon_code")}
                  </Dialog.Title>
                  <div className="mb-4 border rounded-lg bg-neutral-100 p-3">
                    <div className="flex items-center gap-2 mb-2">
                      <p className="text-body-2 text-neutral-500">
                        {t("ticket_type")}
                      </p>
                      <p className="text-sm font-bold text-neutral-800">
                        {ticket ? ticket[nameWithLanguage] : ""}
                      </p>
                    </div>
                    <div className="flex items-center gap-2">
                      <p className="text-body-2 text-neutral-500">
                        {t("price")}
                      </p>
                      <p className="text-sm font-bold text-neutral-800">
                        {currentLanguage === "en"
                          ? `${+ticket?.quantity * +ticket?.price} SR`
                          : `SR ${+ticket?.quantity * +ticket?.price}`}
                      </p>
                    </div>
                  </div>

                  <div className="mb-6">
                    <p className="text-base font-bold text-neutral-800 mb-2">
                      {t("coupon_code")}
                    </p>
                    <input
                      onChange={onChangeCoupon}
                      className="border rounded-lg text-neutral-900 placeholder:text-neutral-300 border-neutral-300 w-full"
                      placeholder="Coupon code"
                    />
                  </div>
                  <div className="flex gap-4">
                    <BaseButton
                      className="w-full px-0 font-bold sm:px-12 text-body-2 sm:text-body-1 text-primary-200"
                      onClick={closeModal}
                      variant="outline"
                      sizeButton="md"
                    >
                      <p className="font-bold text-primary-200 sm:text-body-1 text-body-2">
                        {t("cancel")}
                      </p>
                    </BaseButton>
                    <BaseButton
                      className="w-full px-0 font-bold sm:px-12 text-body-2 sm:text-body-1 text-primary-200"
                      onClick={handleCheckCoupon}
                      sizeButton="md"
                      disable={loading}
                    >
                      {t("apply")}
                    </BaseButton>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
